import React from 'react'
import { Route, Routes } from 'react-router-dom'
import CourierLogin from './pages/CourierLogin'
import PrivateRoute from './components/PrivateRoute'
import Dashboard from './pages/Dashboard'
import Packages from './pages/Packages';
import Couriers from './pages/Couriers';
import Shipments from './pages/Shipments';
import Collections from './pages/Collections';
import Accounts from './pages/Accounts';
import UnknownPackages from './pages/UnknownPackages';
import Claims from './pages/Claims';
import Reports from './pages/Reports';
import Settings from './pages/Settings';


const CourierRoutes = () => {
  return (
    <Routes basename="/courier">
     <Route path="/" element={<CourierLogin />} />
    <Route path="/dashboard" element={<PrivateRoute element={Dashboard} />} />
    <Route path="/packages" element={<PrivateRoute element={Packages} />} />
    <Route path="/accounts" element={<PrivateRoute element={Accounts} />} />
    <Route path="/unknown-packages" element={<PrivateRoute element={UnknownPackages} />} />
    <Route path="/claims" element={<PrivateRoute element={Claims} />} />
    <Route path="*" element={<div>Page Not Found</div>} />
    </Routes>
  )
}

export default CourierRoutes